<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_unsubscribe_data_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
      <gs-button variant="primary" @click="updateUnsubscribeData()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <div class="gm-admin-tab__stack">
      <gs-field class="gm-admin-form" :label="$t('frontend_groovemail_segment_unsubscribe_text')">
        <text-input
          variant="base"
          v-model="model.unsubscribe_text"
          :placeholder="this.$t('frontend_groovemail_sender_enter_unsubscribe_text')"
          :validator="$v.model.unsubscribe_text"
        />
      </gs-field>

      <div class="gm-admin-tab__editor" v-if="unsubscribeDataFetched">
        <email-basic-editor
          ref="unsubscribe-email-editor"
          :editorOptions="unsubscribeEditorOptions"
          :editorContent="model.content"
          :editorNodeWithNoMargin="true"
          :editorWithBlockedLinkRestriction="true"
          :editorDynamicVariables="dynamicVariables"
          :editorClasses="editorClasses"
          openedFrom="admin"
          :allowEditorPreview="false"
          :allowEditorHtmlView="true"
          @editorContentUpdated="model.content = $event"
        ></email-basic-editor>
      </div>

      <p
        v-if="
          dataSubmitted &&
          ((this.model.content &&
            !this.model.content.includes('{unsubscribe_text}')) ||
            !this.model.content)
        "
        class="gm-admin-tab__error"
      >
        {{ $t('frontend_groovemail_admin_unsubscribe_setting_include_unsubscribe_text') }}
      </p>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import EmailBasicEditor from '@/components/EmailBasicEditor.vue';
import { adminUrls } from '@/utils/urls.js';	
import { getData, postData } from '@/utils/apiHelper.js';

export default {
  data() {
    return {
      model: {
        content: '',
        unsubscribe_text: '',
      },
      dataSubmitted: false,
      unsubscribeDataFetched: false,
      unsubscribeEditorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              [{ list: 'ordered' }, { list: 'bullet' }],

              ['link', 'image'],
              [{ size: ['10px', false, '18px', '32px'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ align: [] }],
            ],
            handlers: {
              image: () => this.handleImageInsertionInContent()
            },
          },
        },
      },
    };
  },

  validations: {
    model: {
      content: {
        required,
      },
      unsubscribe_text: {
        required,
      },
    },
  },

  components: {
    EmailBasicEditor,
  },

  computed: {
	  /**	
     * Returns list of dynamic variables to use in editor.	
     * @return {array} - array of dynamic variables.	
     */
    dynamicVariables() {
      return [
        {
          label: this.$t('frontend_groovemail_contacts_step2_company'),
          value: '{sender_company}',
        },
        {
          label: this.$t('frontend_groovemail_segment_company_address'),
          value: '{sender_address}',
        },
        {
          label: this.$t('frontend_groovemail_segment_unsubscribe_text'),
          value: '{unsubscribe_text}',
        },
      ];
    },
		
    /**	
     * Returns classes for editor label.	
     * @return {string} - classes for for editor label.	
     */
    editorClasses() {
      return {
        labelClasses: 'font-semibold text-sm text-grey-700',
      };
    },
  },

  methods: {
    // Opens a modal for image insertion.	
    handleImageInsertionInContent() {
      this.$refs['unsubscribe-email-editor'].handleImageInsertionInContent(); 
    },

    // Fetches unsubscribe layout data and initialize them to data properties.	
    async initializeUnsubscribeLayoutData() {
      const unsubscribeData = await getData(adminUrls.mainSettingsUrl.fetchUnsubscribeData);	
      this.model.content = unsubscribeData.data.footer_layout;
      this.model.unsubscribe_text = unsubscribeData.data.unsubscribe_text;
      this.unsubscribeDataFetched = true;
    },

    // Validates and save unsubscribe layout data.	
    async updateUnsubscribeData() {
      this.dataSubmitted = true;
      this.$v.model.$touch();
      if (
        this.model.content &&
        this.model.content.includes('{unsubscribe_text}') &&
        !this.$v.model.unsubscribe_text.$invalid
      ) {
        await postData(adminUrls.mainSettingsUrl.updateUnsubscribeDataSetting, {	
          footer_layout: this.model.content,	
          unsubscribe_text: this.model.unsubscribe_text,	
        });
      }
    },
  },

  // Initialize data properties with unsubscribe layout data.	
  async created() {
    await this.initializeUnsubscribeLayoutData();
  },
};
</script>